module.exports = __webpack_public_path__ + "media/images/icons/material/share-da84feae895dbabc6392edb4dd722aad.svg";